@if (!isHabilited) {
  <oui-banner
    title="Vous n'avez aucune habilitation active pour ce produit"
    declination="error"
  [action]="noHabilAction"></oui-banner>
}
<div class="flex-vertical gap-32">
  @if (operation) {
    <app-souscription-file-items
      [operation]="operation"
      [operationIndex]="index"
      [fichierOperations]="operationFilesToDisplay"
      [showBannerSouscription]="true"
      (onAddedFile)="addFichierOperation($event)"
      [withGlobalAddFilesButton]="true"
      (onRemoveFile)="onFileRemoved()">
    </app-souscription-file-items>
  }
</div>
